<template>
    <div class="no-networks-overlay">
        <div class="no-data-header font-8">
            SETUP AVAILABLE AD NETWORKS (0)
        </div>
        <NoDataOverlay :isShown="isShown"
                       class="no-data-overlay"
                       icon="noDataAvailableIcon"
                       iconWidth="122"
                       iconHeight="92"
                       mainText="No networks defined yet"
                       mainTextClass="headlineSmall no-data-overlay-main-text">
            <div slot="subText" class="font-7 no-data-overlay-subtext">
                To add networks click on the manage networks above
            </div>
        </NoDataOverlay>
        </div>
</template>

<script>
import NoDataOverlay from 'components/noDataOverlay/noDataOverlay.vue';

export default {
    name: 'NoNetworksOverlay',
    components: { NoDataOverlay },
    props: {
        isShown: Boolean
    }
};
</script>

<style scoped lang="scss">
@import "~styles/styleGuide";

.no-networks-overlay {
    height: 258px;
    border: $border;
    margin-bottom: 15px;
}

.no-data-header {
    line-height: 35px;
    padding-left: 20px;
    border-bottom: $border;
    color: $light-800;
}

.no-data-overlay {
    position: relative;
    padding-top: 22px;
}

</style>
